import { render } from "./TarjetaDetalle.vue?vue&type=template&id=0896949e&scoped=true&ts=true"
import script from "./TarjetaDetalle.vue?vue&type=script&lang=ts"
export * from "./TarjetaDetalle.vue?vue&type=script&lang=ts"

import "./TarjetaDetalle.vue?vue&type=style&index=0&id=0896949e&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0896949e"]])

export default __exports__